/**
 * Contentful Management API SDK. Allows you to create instances of a client
 * with access to the Contentful Content Management API.
 * @packageDocumentation
 */
import createContentfulApi from './create-contentful-api';
import { createCMAHttpClient } from './create-cma-http-client';
import { createPlainClient } from './plain/plain-client';
export { asIterator } from './plain/as-iterator';
export { isDraft, isPublished, isUpdated } from './plain/checks';

function createClient(params) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var client;

  if (opts.type === 'plain') {
    client = createPlainClient(params, opts.defaults);
  } else {
    var http = createCMAHttpClient(params);
    client = createContentfulApi({
      http: http
    });
  }

  return client;
}

export { createClient };